<template>
  <div id="findpassword">
    <!--头部导航-->
    <GlobTopNav title="忘记密码"></GlobTopNav>
    <div class="login-cont">
      <div class="van-cell">
        <img src="./../../assets/img/iphone.svg" alt="" />
        <div class="van-cell__value">
          <input
            onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
            type="number"
            placeholder="请输入手机号"
            v-model="mobile"
            class="van-field__control"
          />
        </div>
      </div>
      <div class="codebox van-cell">
        <img src="./../../assets/img/login-code.svg" alt="" />
        <div class="van-cell__value">
          <input type="number" placeholder="短信验证码" v-model="code" class="van-field__control" />
        </div>
        <div class="van-field__button">
          <van-button class="get-code" slot="button" @click="getNvc()" :loading="codeLoading">
            获取验证码
          </van-button>
        </div>
      </div>
      <div class="van-cell">
        <img src="./../../assets/img/login-pwd.svg" alt="" />
        <div class="van-cell__value">
          <input
            type="password"
            placeholder="请输入密码（6-12位字符）"
            v-model="password"
            class="van-field__control"
          />
        </div>
      </div>
      <div style="margin-bottom: 10px" class="van-cell">
        <img src="./../../assets/img/login-pwd.svg" alt="" />
        <div class="van-cell__value">
          <input
            type="password"
            placeholder="再次确认密码"
            v-model="repassword"
            class="van-field__control"
          />
        </div>
      </div>

      <van-button size="large" class="loginbtn" @click="senData()" :loading="loading">
        确定
      </van-button>
    </div>
    <Nvc 
      ref="nverify" 
      :verify="verifyMethods"
    ></Nvc>
  </div>
</template>

<script>
import Nvc from "../login/components/nvc";
import TopNav from "@/components/topnav";
export default {
  name: "index",
  components: {
    TopNav,
    Nvc
  },
  data() {
    return {
      loading: false,
      codeLoading: false,
      mobile: "",
      password: "",
      repassword: "",
      code: "",
      No: "",
      dd: "",
      nvcType: 1
    };
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    getNvc: function() {
      // 进行人机验证
      const reg = /^[1][0-9][0-9]{9}$/;
      if (this.mobile == "") {
        this.$toast("请输入手机号");
        return;
      }
      if (!reg.test(this.mobile)) {
        this.$toast("请输入正确的手机号码");
        return;
      }
      this.nvcType = 1
      this.$refs.nverify.startVerify()
    },
    getCode: function(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        var _this = this;
        var mallid = localStorage.getItem("mallid");
        if (this.codeLoading == false) {
          this.codeLoading = true;
          this.$api.post(
            "message",
            { id_example: mallid, phone: this.mobile, type: 4, captchaVerifyParam },
            res => {
              if (res.data.code == "100") {
                this.No = res.data.data;
                var time = 60;
                _this.dd = setInterval(function() {
                  time--;
                  $("#findpassword .codebox .van-button").html(time + " s");
                  if (time <= 0) {
                    clearInterval(_this.dd);
                    _this.codeLoading = false;
                    $("#findpassword .codebox .van-button").html(
                      '<span class=\\"van-button__text\\">重新发送</span>'
                    );
                  }
                }, 1000);
                this.$toast("发送成功请注意查收");
                resolve(true)
              } else if (
                res.data.code == "400"
              ) {
                resolve(false)
                _this.codeLoading = false;
              } else if (res.data.code == "800") {
                this.$toast("登录次数过多请稍后再试");
                _this.codeLoading = false;
                resolve(true)
              } else {
                this.$toast(res.data.message);
                _this.codeLoading = false;
                resolve(true)
              }
            }
          );
        }
      })
      
    },
    senData: function() {
      var mobilereg = /^[1][3456789][0-9]{9}$/;
      if (!mobilereg.test(this.mobile)) {
        this.$toast("请输入正确的手机号码");
        return false;
      }
      var code = this.No + "_" + this.code;
      if (code == "_") {
        this.$toast("请输入验证码");
        return false;
      }
      var reg = new RegExp(/^[0-9a-zA-Z]+$/);
      if (!reg.test(this.password)) {
        this.$toast("密码只能输入数字或字母！");
        return false;
      }
      this.nvcType = 2
      this.$refs.nverify.startVerify()
    },
    comit(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        var mallid = localStorage.getItem("mallid");
        var code = this.No + "_" + this.code;
        this.loading = true;
        this.$api.post(
          "user/find/pwd",
          {
            id_example: mallid,
            phone: this.mobile,
            code: code,
            password: this.password,
            repassword: this.repassword,
            captchaVerifyParam
          },
          res => {
            if (res.data.code == "100") {
              this.$toast("密码已修改成功，请重新登录！");
              localStorage.removeItem("BLHuser");
              localStorage.removeItem("user_id");
              this.$router.push({ name: "NoteLogin" });
              this.$store.commit("userInfo");
              resolve(true)
            } else if (
              res.data.code == "400"
            ) {
              resolve(false)
            } else {
              this.$toast(res.data.message);
              resolve(true)
            }
            this.loading = false;
          }
        );
      })
     
    },
    verifyMethods(captchaVerifyParam) {
      if(this.nvcType === 1) {
        return new Promise(async(resolve, reject) => {
          const data = await this.getCode(captchaVerifyParam)
          resolve(data)
        })
      } else {
        return new Promise(async(resolve, reject) => {
          const data = await this.comit(captchaVerifyParam)
          resolve(data)
        })
      } 
    }
  },
  mounted() {},
  destroyed: function() {
    clearInterval(this.dd);
    $("#findpassword .codebox .van-button").html(
      '<span class=\\"van-button__text\\">获取验证码</span>'
    );
  }
};
</script>

<style scoped lang="less">
#findpassword {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/img/login-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .login-box {
    text-align: center;
    padding-top: 0.6rem;

    .logo {
      width: auto;
      min-width: 1.84rem;
      max-width: 1.84rem;
    }
  }

  .login-cont {
    margin-top: 0.84rem;
    box-sizing: border-box;
    padding: 0 0.6rem;

    .van-cell {
      padding: 0.46rem 0;
      border-bottom: 0.01rem solid #dfdfdf;
      background: transparent !important;
      display: flex;
      align-items: center;

      &::after {
        border: none;
      }

      img {
        width: 0.48rem;
        height: 0.48rem;
      }

      .van-cell__value {
        padding-left: 0.2rem;

        .van-field__control {
          &::placeholder {
            color: rgba(38, 38, 38, 0.5);
          }
        }
      }
      .inputlabel {
        color: rgba(80, 80, 80, 0.6rem);
        font-size: 0.4rem;
      }

      .van-field__button {
        .get-code {
          min-width: 1.68rem;
          height: 0.52rem;
          background: #fe5c42;
          border-radius: 0.08rem;
          color: #fff;
        }
        .code {
          width: 1.68rem;
          height: 0.88rem;

          .s-canvas {
            width: 100%;
            height: 100%;
            #s-canvas {
              width: 1.68rem;
              height: 0.88rem;
            }
          }
        }
      }
    }

    .loginbtn {
      width: calc(100% - 0.6rem);
      height: 0.96rem;
      margin-left: 0.3rem;
      background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
      border-radius: 0.48rem;
      font-size: 0.3rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.42rem;
      margin-top: 0.6rem;
    }

    .text-cent {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.4rem;
      font-size: 0.28rem;
      font-weight: 400;
      color: rgba(38, 38, 38, 0.5);
      line-height: 0.48rem;

      .ljdl {
        font-size: 0.28rem;
        font-weight: 400;
        color: #025bff;
        line-height: 0.48rem;
      }
    }

    .login-text {
      margin-top: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .forgot-password {
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.5);
        line-height: 0.48rem;
      }

      .restBox {
        width: 1.12rem;
        height: 0.4rem;
        font-size: 0.28rem;
        font-weight: 500;
        color: #025bff;
        line-height: 0.48rem;
      }
    }
  }

  .other-way {
    box-sizing: border-box;
    padding: 1rem 2rem 0 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .login_wx {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 0.88rem;
        height: 0.88rem;
      }

      span {
        margin-top: 0.2rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: #929292;
        line-height: 0.42rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/backpass/index.vue